// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2aH91","tableActions":"JpqlL","left":"_3P9jN","unnamedTeam":"_24GB2","image":"_2Wcb0","empty":"_1pGrM","details":"_12aBV"};